import React from 'react';
import { Variant } from 'components/variant/Variant';

export const VariantSlice = ({ image, ndc, strength, form, size, gcn, gcnSeq }) => {
  return <Variant image={image} ndc={ndc} strength={strength} size={size} cgn={gcn} seq={gcnSeq} />;
};

export default VariantSlice;
